import React from 'react'

function Timer ({ className, fill }) {
  return (
    <svg fill={fill} className={className} width="30" height="30" viewBox="0 0 30 30">
      <path d="M15,30A15,15,0,1,1,30,15,15.021,15.021,0,0,1,15,30ZM15,1.428A13.572,13.572,0,1,0,28.572,15,13.588,13.588,0,0,0,15,1.428Zm0,0" />
      <path d="M223.645,35.561,213.332,25.248V10.668h1.429V24.659l9.893,9.893Zm0,0" transform="translate(-199.046 -9.954)" />
      <path d="M213.332,362.668h1.429v5h-1.429Zm0,0" transform="translate(-199.046 -338.382)" />
      <path d="M10.668,213.332h5v1.429h-5Zm0,0" transform="translate(-9.954 -199.046)" />
      <path d="M66.643,65.57l3.384,3.384-1.01,1.01-3.384-3.384Zm0,0" transform="translate(-61.238 -61.179)" />
      <path d="M68.968,316.656l1.01,1.01-3.39,3.39-1.01-1.01Zm0,0" transform="translate(-61.187 -295.452)" />
    </svg>
  )
}

Timer.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Timer
